import { store } from './store';
import DB from '../../DAL/DB';
import { auth } from '../../Auth';
import { setProject } from '../action_creators';

const projects = new DB.Projects();

export default async function saveImages() {
  const state = store.getState();
  const { project, fields } = state;
  //console.info('saveImages', fields[project.id].images);

  // Create a new project object to avoid mutating the state
  const updatedProject = {
    ...project,
    photos: fields[project.id].images || {},
  };

  try {
    await projects.updatebatch(
      updatedProject.id,
      {
        noMerge: true,
      },
      {
        ...updatedProject,
        updatedBy: auth?.sunkaizenUser?.id,
        updatedByName: auth?.sunkaizenUser?.name,
      }
    );

    // Optionally update the Redux store to reflect the change
    store.dispatch(setProject(updatedProject));
  } catch (e) {
    console.log(e);
    throw e;
  }
}